<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/logo-teman-bakat.png" height="90px" alt="" />
      </section>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/stress/label.png" height="90px" alt="" />
      </section>
      <section class="pa-3">
        <div class="d-flex justify-center" v-if="result.kategori === 'Tinggi'">
          <img
            src="../../assets/img/stress/cat_tinggi.png"
            height="200px"
            alt=""
          />
        </div>
        <div class="d-flex justify-center" v-if="result.kategori === 'Sedang'">
          <img
            src="../../assets/img/stress/cat_sedang.png"
            height="200px"
            alt=""
          />
        </div>
        <div class="d-flex justify-center" v-if="result.kategori === 'Rendah'">
          <img
            src="../../assets/img/stress/cat_rendah.png"
            height="200px"
            alt=""
          />
        </div>

        <div class="d-flex justify-center">
          <div class="rs_ pa-3 rounded-lg">
            <p class="white--text ma-0">
              skor <b>{{ result.rs }}</b> | Tingkat Stres
              <b>{{ result.kategori }}</b>
            </p>
          </div>
        </div>
        <v-card class="pa-3 rounded-lg mt-3" flat>
          <p class="mb-1 purple--text">
            <strong>Deskripsi:</strong>
          </p>
          <p class="text-justify">{{ result.deskripsi }}</p>
        </v-card>
      </section>
    </div>
    <uiDownload />
  </div>
</template>

<script>
import uiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { uiDownload },
  name: "resultStresKerja",
  data() {
    return {
      result: "",
    };
  },
  mounted() {
    let data = JSON.parse(localStorage.getItem("streskerja"));
    this.result = JSON.parse(data.result);
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 100vh;
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.type {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.rounded-max {
  border-radius: 15px;
}
.code {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #1e656c;
  color: white;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
.rs_ {
  width: max-content;
  background: #1e656c;
}
</style>
